class OptionsController {
    /*@ngInject*/
    constructor($state) {
        "ngInject";
        _.extend(this, {
        	name: 'options',
        	$state: $state
        });
    }

    goToHome() {
    	this.$state.go('base.basic', {orderId: new Date().getTime()});
    }

}


export default OptionsController;


// WEBPACK FOOTER //
// ./client/app/components/options/options.controller.js